import React from "react";
import { ArrowUpRight } from "lucide-react";
import { personalInfo } from "../data/mock";
import { useReveal } from "../hooks/useReveal";

const GetInTouch = () => {
  const revealRef = useReveal();

  return (
    <div className="py-24 md:py-40 border-t border-rule">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div ref={revealRef} className="reveal max-w-3xl mx-auto text-center">
          <p className="font-mono text-sm text-accent mb-4">05. What's next</p>

          <h2 className="font-sans font-semibold text-4xl sm:text-5xl md:text-6xl text-ink tracking-tightest leading-[1] mb-6">
            Get in touch.
          </h2>

          <p className="text-base md:text-lg text-ink-2 leading-relaxed max-w-xl mx-auto mb-10">
            The fastest way to reach me is email. Happy to talk backend work, a role, or
            just an interesting system you're wrestling with.
          </p>

          <a
            href={`mailto:${personalInfo.email}`}
            className="group inline-flex items-center gap-2.5 px-7 py-4 border border-accent text-accent rounded-md hover:bg-accent-dim transition-all font-mono text-sm"
          >
            {personalInfo.email}
            <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" strokeWidth={2} />
          </a>

          <div className="mt-14 flex items-center justify-center gap-x-8 gap-y-2 font-mono text-xs uppercase tracking-widest flex-wrap">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-ink-3 hover:text-ink transition-colors"
            >
              github ↗
            </a>
            <span className="text-ink-3">/</span>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="text-ink-3 hover:text-ink transition-colors"
            >
              linkedin ↗
            </a>
            <span className="text-ink-3">/</span>
            <span className="text-ink-3">{personalInfo.location}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
